export const providersTextContent = {
  providersContent: [
    {
      imageContent: [
        { imageSrc: "/assets/stock-img/provider_logo_01.webp" },
        { imageSrc: "/assets/stock-img/provider_logo_02.webp" },
        { imageSrc: "/assets/stock-img/provider_logo_03.webp" },
        { imageSrc: "/assets/stock-img/provider_logo_04.webp" },
        { imageSrc: "/assets/stock-img/provider_logo_01.webp" },
        { imageSrc: "/assets/stock-img/provider_logo_02.webp" },
        { imageSrc: "/assets/stock-img/provider_logo_03.webp" },
        { imageSrc: "/assets/stock-img/provider_logo_04.webp" },
      ],
    },
  ],
};
